<template>
  <div
    class="star"
    :style="{ padding: starData.length > 2 ? '80px 20px' : '80px 120px' }"
  >
    <h2>企业优势</h2>
    <div
      class="solution"
      :style="{ 'max-width': starData.length > 2 ? '1440px' : '1350px' }"
    >
      <div
        class="solution_item"
        v-for="(item, i) in starData"
        :key="i"
        :style="{ background: 'url( ' + item.img + ')' }"
      >
        <div class="mask"></div>
        <div
          class="content"
          :style="{
            padding: starData.length > 2 ? '45px 28px' : '90px 28px'
          }"
        >
          <div class="nameWrapper">
            <strong>{{ item.title }}</strong>
          </div>
          <div
            class="desc"
            v-html="item.content"
            :style="{
              'margin-top': starData.length > 2 ? '25px' : '67px'
            }"
          ></div>

          <!-- <p class="desc" style="margin-top:30px">
            系统中的包牌贷产品，根据客户的资金实力及实际情况进行量身定制，帮助其以最合适的价格下单，灵活便捷，在客户中的良好口碑日益传播开，助力公司市场占有率快速提升。
          </p> -->
        </div>
        <router-link
          :to="{
            name: ylStatus ? 'business_yl' : 'business',
            query: { routerPath: 'qyys' }
          }"
        >
          <div class="btns">
            <el-button type="primary">查看详情</el-button>
          </div>
        </router-link>
      </div>
      <!-- <div class="solution_item back_sec">
        <div class="mask"></div>
        <div class="content">
          <div class="nameWrapper">
            <strong>大客户架构</strong>
          </div>
          <p class="desc">
            通过大客户架构，使经销商与品农的合作更加紧密，双方互惠共赢；经销商可享受到品农更加优惠的政策和更优质的服务，提高在当地的市场占有率，进一步做大做强；品农也会有稳定的客户并提高在市场的竞争力和影响力。
          </p>
        </div>
        <router-link :to="{ name: 'business', query: { routerPath: 'qyys' } }">
          <div class="btns">
            <el-button type="primary">查看详情</el-button>
          </div>
        </router-link>
      </div> -->
      <!-- <div class="solution_item back_thi">
        <div class="mask"></div>
        <div class="content">
          <div class="nameWrapper">
            <strong>行业资源</strong>
          </div>
          <p class="desc">
            公司5位高管有着二十多年金融、商用车、科技行业从业及管理经验，积累了丰富的金融行业资源，深谙商用车后市场的节点流程及市场痛点，善用科技手段解决商用车金融服务问题。
          </p>
        </div>
        <router-link :to="{ name: 'business', query: { routerPath: 'qyys' } }">
          <div class="btns">
            <el-button type="primary">查看详情</el-button>
          </div>
        </router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import { getAdvantage } from '@/api/home'

export default {
  name: 'StarProduct',
  data() {
    return {
      starData: [],
      ylStatus: this.$store.getters.urlStatus
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getAdvantage()
        .then(res => {
          let data = res.data
          this.starData = data
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.star {
  background: #fff;
  // padding: 80px 120px;
  strong {
    color: rgba(255, 255, 255, 1);
    font-size: 30px;
    font-weight: 400;
  }
  h2 {
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    color: rgba(35, 35, 35, 1);
  }
  .solution {
    // max-width: 1350px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 62px;
    .solution_item {
      box-shadow: 0 0 8px 0 rgba(211, 216, 239, 0.4);
      overflow: hidden;
      width: 45%;
      height: 525px;
      -webkit-transition: width 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
      -o-transition: width 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: width 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
      border: 1px solid #efefef;
      position: relative;
      background-position: 50% !important;
      border: 1px solid hsla(0, 0%, 53.3%, 0.1);
      border-right: none;
      background-repeat: no-repeat !important;
      background-size: cover !important;

      .content {
        position: relative;
        color: #fff;
        height: 100%;
        position: relative;
        overflow: hidden;
        text-align: start;
        text-align: initial;
        strong {
        }
        .desc {
          font-size: 16px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1) !important;
          // text-indent: 35px;

          /deep/p {
            font-size: 16px !important;
            font-weight: 400 !important;
            color: rgba(255, 255, 255, 1) !important;
            line-height: 34px !important;
            span {
              font-size: 16px !important;
              font-weight: 400 !important;
              color: rgba(255, 255, 255, 1) !important;
              line-height: 34px !important;
            }
          }
        }
      }
      .btns {
        position: absolute;
        left: 28px;
        bottom: 50px;
        background: #0d7ef8;
      }
      .el-button--primary {
        border-radius: 0;
      }
    }
    .mask {
      -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      -o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      /* transition: all .3s cubic-bezier(.645,.045,.355,1); */
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: rgba(3, 38, 82, 0.48);
    }
    .solution_item:hover {
      width: 50%;
    }
    .solution_item:hover .mask {
      display: none;
    }

    // .back_fis {
    //   background-image: url('../../assets/image/business1.png') !important;
    // }
    // .back_sec {
    //   background-image: url('../../assets/image/business2.png');
    // }
    // .back_thi {
    //   background-image: url('../../assets/image/business3.png');
    // }
  }
}
</style>
